import { render, staticRenderFns } from "./procedure-template-card.vue?vue&type=template&id=03385a7a&"
import script from "./procedure-template-card.vue?vue&type=script&lang=js&"
export * from "./procedure-template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports